import axios from '@/libs/api.request'

/**
 * 获取行业分类列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词（code或name）
 * @param {string} params.load_children - 加载指定父级的子分类
 */
export const getIndustryList = (params = {}) => {
  return axios.request({
    url: '/api/admin/industry/list',
    method: 'get',
    params
  })
}

/**
 * 懒加载子分类
 * @param {string} parentCode - 父级代码
 */
export const loadIndustryChildren = (parentCode) => {
  return axios.request({
    url: '/api/admin/industry/list',
    method: 'get',
    params: { load_children: parentCode }
  })
}

/**
 * 创建行业分类
 * @param {Object} data - 行业分类数据
 */
export const createIndustry = (data) => {
  return axios.request({
    url: '/api/admin/industry/create',
    method: 'post',
    data
  })
}

/**
 * 更新行业分类
 * @param {number} id - 行业分类ID
 * @param {Object} data - 更新数据
 */
export const updateIndustry = (id, data) => {
  return axios.request({
    url: `/api/admin/industry/update/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除行业分类
 * @param {number} id - 行业分类ID
 */
export const deleteIndustry = (id) => {
  return axios.request({
    url: `/api/admin/industry/delete/${id}`,
    method: 'delete'
  })
}

/**
 * 设置产业类型（仅一级分类）
 * @param {number} id - 行业分类ID
 * @param {number} industryType - 产业类型 1:第一产业 2:第二产业 3:第三产业
 */
export const setIndustryType = (id, industryType) => {
  return axios.request({
    url: `/api/admin/industry/type/${id}`,
    method: 'put',
    data: { industry_type: industryType }
  })
}

/**
 * 发布新版本
 * @param {Object} data - 版本数据
 * @param {string} data.update_note - 更新说明
 */
export const publishVersion = (data) => {
  return axios.request({
    url: '/api/admin/industry/version',
    method: 'post',
    data
  })
}

/**
 * 获取当前版本信息
 */
export const getCurrentVersion = () => {
  return axios.request({
    url: '/api/industry/version',
    method: 'get'
  })
}
